import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "video-play",
  "use": "video-play-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"video-play\">\n<circle cx=\"32\" cy=\"32\" r=\"32\" fill=\"white\" fill-opacity=\"0.2\" />\n<path d=\"M39.8571 32.5L27 40L27 25L39.8571 32.5Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol